var map = {
	"./icon-0.svg": "f762",
	"./icon-1.svg": "4db6",
	"./icon-2.svg": "f442",
	"./icon-3.svg": "1ab1",
	"./icon-4.svg": "08a4",
	"./icon-5.svg": "d689",
	"./icon-6.svg": "6f25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2624";